import React, { useEffect, useRef, useState } from 'react';
import { geoMercator, geoPath } from 'd3-geo';
import { feature } from 'topojson-client';

// Robustly resolve any office label (e.g. "Canada", "Canada Office", "USA Office",
// "United States") to a display label + the dataset country name.
export function resolveCountry(input) {
  const s = String(input || '').toLowerCase();
  if (s.includes('canada')) return { label: 'Canada', geo: 'Canada' };
  if (
    s.includes('united states') ||
    s.includes('u.s.a') ||
    s.includes('usa') ||
    s.includes('america') ||
    /\bus\b/.test(s)
  ) {
    return { label: 'United States', geo: 'United States of America' };
  }
  return { label: input || '', geo: input || '' };
}

const W = 640;
const H = 420;

let _cache = null;
async function loadFeatures() {
  if (_cache) return _cache;
  const res = await fetch('/geo/countries-110m.json');
  const topo = await res.json();
  _cache = feature(topo, topo.objects.countries).features;
  return _cache;
}

// A clean map of a SINGLE country, filled soft ivory with a red outline,
// fitted to the frame (no surrounding world).
export const CountryMap = ({ country, className = '' }) => {
  const [d, setD] = useState(null);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    const { geo, label } = resolveCountry(country);
    loadFeatures()
      .then((features) => {
        const f = features.find((x) => (x.properties && x.properties.name) === geo);
        if (!f || !mounted.current) return;
        const projection = geoMercator().fitExtent(
          [[24, 24], [W - 24, H - 24]],
          f
        );
        setD(geoPath(projection)(f));
      })
      .catch(() => {});
    return () => { mounted.current = false; };
  }, [country]);

  const { label } = resolveCountry(country);
  return (
    <div className={`w-full h-full bg-ophir-ivory-soft ${className}`}>
      <svg
        viewBox={`0 0 ${W} ${H}`}
        className="w-full h-full"
        role="img"
        aria-label={`Map of ${label}`}
        preserveAspectRatio="xMidYMid meet"
      >
        <rect x="0" y="0" width={W} height={H} fill="#FBF9F4" />
        {d && (
          <path
            d={d}
            fill="#F1D28F"
            fillOpacity="0.35"
            stroke="#B42318"
            strokeWidth="1.6"
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        )}
      </svg>
    </div>
  );
};
